module.exports = __webpack_public_path__ + "static/media/ic_info_outline_24px.8268f62d.svg";